<template>
  <el-row style="padding-bottom: 10px; position: relative">
    <el-col style="text-align: right; margin-bottom: 10px">
      <el-button size="mini" type="primary" @click="addLouDon"
        >添加楼栋</el-button
      >
    </el-col>
    <el-table
      :max-height="height - 50 + 'px'"
      :data="data"
      style="width: 100%"
      size="mini"
    >
      <el-table-column
        prop="BuildingCode"
        label="楼栋编号"
        sortable
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="BuildingName"
        label="楼栋名称"
        sortable
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="Formats"
        label="业态"
        sortable
        align="left"
        width="200px"
      >
      </el-table-column>
      <el-table-column
        prop="Construction_Area"
        label="建筑面积(m²)"
        align="right"
        width="150px"
        sortable
      >
        <template slot-scope="scope">
          <div class="list_column">
            {{
              scope.row.Construction_Area ? scope.row.Construction_Area : 0
            }}㎡
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="Above_Ground_Floors"
        label="地上层数"
        align="right"
        sortable
        width="130px"
      >
        <template slot-scope="scope">
          <div class="list_column">
            {{
              scope.row.Above_Ground_Floors ? scope.row.Above_Ground_Floors : 0
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="Underground_Floors"
        label="地下层数"
        align="right"
        sortable
        width="130px"
      >
        <template slot-scope="scope">
          <div class="list_column">
            {{
              scope.row.Underground_Floors ? scope.row.Underground_Floors : 0
            }}
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column label="备注" prop="Remark"></el-table-column> -->
      <el-table-column label="操作" align="center" width="100px">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="itemClick(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="text" @click="itemDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="楼栋维护"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="70%"
    >
      <el-form
        class="form"
        v-show="dialogVisible"
        :model="entity"
        ref="entity"
        label-width="120px"
        label-position="right"
      >
        <el-card
          v-for="(item, index) in formData"
          :key="index"
          style="margin-bottom: 10px"
        >
          <el-collapse v-model="activeBuildingNames">
            <el-collapse-item
              :title="`楼栋：${
                formData[index].BuildingCode ? formData[index].BuildingCode : ''
              }`"
              :name="`楼栋${index}`"
            >
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item prop="BuildingCode">
                    <span slot="label"
                      ><span style="color: red">*</span> 楼栋编号</span
                    >
                    <el-input v-model="item.BuildingCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="楼栋名称" prop="BuildingName">
                    <span slot="label"
                      ><span style="color: red">*</span> 楼栋名称</span
                    >
                    <el-input v-model="item.BuildingName"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="建筑面积" prop="Construction_Area">
                    <span slot="label"
                      ><span style="color: red">*</span> 建筑面积</span
                    >
                    <el-input
                      :placeholder="'建筑面积'"
                      v-model="item.Construction_Area"
                      type="number"
                    >
                      <span slot="suffix">m²</span>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="业态" prop="Formats">
                    <!-- <el-input
                      :placeholder="index == 0 ? '' : '同上'"
                      v-model="item.Construction_Area"
                      type="number"
                    >
                      <span slot="suffix">m²</span>
                    </el-input> -->
                    <el-select
                      v-model="item.Formats"
                      filterable
                      placeholder="选择业态"
                    >
                      <el-option
                        v-for="item in YetaiList"
                        :key="item.Id"
                        :label="item.DicName"
                        :value="item.DicName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="地上层数" prop="Above_Ground_Floors">
                    <el-input
                      placeholder="地上层数"
                      v-model="item.Above_Ground_Floors"
                      type="number"
                      oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')"
                      @input="handleInput($event, item)"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="地下层数" prop="Underground_Floors">
                    <el-input
                      placeholder="'地下层数'"
                      v-model="item.Underground_Floors"
                      type="number"
                      oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')"
                      @input="handleInput2($event, item)"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="18">
                  <el-form-item label="备注" prop="Remark">
                    <el-input
                      v-model="item.Remark"
                      type="textarea"
                      :autosize="{ minRows: 2 }"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="18">
                  <el-form-item label="设备分类">
                    <el-tree
                      :data="ecList"
                      show-checkbox
                      node-key="id"
                      :default-expand-all="true"
                      :props="defaultProps"
                      ref="tree"
                      :default-expanded-keys="defaultKeys"
                      @check-change="
                        (data, checked, indeterminate) =>
                          handleCheckChange(data, checked, indeterminate, item, index)
                      "
                    >
                    </el-tree>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6" v-if="addAndRemove">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="BuildingRemoval(index)"
                    >移除</el-button
                  >
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </el-form>
      <div class="buttonGroup">
        <el-button
          size="mini"
          v-if="addAndRemove"
          type="success"
          @click="BuildingAddition"
          >追 加</el-button
        >
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="louDonConfirm"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      entity: {},
      data: [],
      ecList: [],
      formData: [],
      YetaiList: [],
      itemYtShow: [],
      addAndRemove: true,
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      defaultKeys: [0], // 指定哪些节点的子节点默认展开
      activeBuildingNames: ['楼栋0'],
    }
  },
  mounted() {
    this.getDataList()
    this.getYeTaiList()
    // this.getFlList();
  },
  computed: {
    height() {
      return document.documentElement.clientHeight - 60
    },
  },
  methods: {
    handleInput(num, item) {
      console.log(num, item)
      if (Number(num) > 999) {
        this.$notify.error('地上层数最大不能超过999')
        this.$set(item, 'Above_Ground_Floors', 999)
      } else if (Number(num) < 0) {
        this.$notify.error('地上层数层数不能为负数')
        this.$set(item, 'Above_Ground_Floors', 0)
      }
    },
    handleInput2(num, item) {
      console.log(num, item)
      if (Number(num) > 20) {
        this.$notify.error('地下层数最大不能超过20')
        this.$set(item, 'Underground_Floors', 20)
      } else if (Number(num) < 0) {
        this.$notify.error('地下层数层数不能为负数')
        this.$set(item, 'Underground_Floors', 0)
      }
    },
    // 业态选择
    YetaiChange(e, obj) {
      for (const key in obj.Formats) {
        obj.Formats[key].show = e.includes(key)
      }
      e.forEach((item) => {
        if (!obj.Formats[item]) this.$set(obj.Formats, item, { show: true })
      })
      console.log(obj.Formats)
      console.log(obj, 'obj')
      this.itemYtShow = this.formData.map((item, index) => index)
    },
    handleCheckChange(data, checked, indeterminate, item, index) {
      console.log(data, checked, indeterminate, item, index)
      console.log(this.$refs.tree[index].getCheckedKeys())
      this.$set(
        item,
        'EquipmentClassificationIds',
        JSON.stringify(this.$refs.tree[index].getCheckedKeys())
      )
      console.log(item)
    },
    // 添加楼栋
    addLouDon() {
      this.addAndRemove = true
      if (this.dialogVisible) this.dialogVisible = false
      this.formData = [{}]
      this.activeBuildingNames = []
      this.formData.forEach((item, index) => {
        this.activeBuildingNames.push('楼栋' + index)
      })
      setTimeout(() => {
        this.dialogVisible = true
      }, 200)
    },
    // 删除
    itemDel(obj) {
      this.$http
        .post('/Base_ProjectManage/Project_Building/DeleteData', [obj.Id])
        .then((res) => {
          if (res.Success) {
            this.getDataList()
            this.$notify.success('操作成功')
          } else this.$notify.error(res.Msg)
        })
    },
    // 编辑
    itemClick(obj) {
      this.formData = []
      console.log(obj, 'EquipmentClassificationIds')
      this.addAndRemove = false
      this.dialogVisible = true
      this.formData = [JSON.parse(JSON.stringify(obj))]
      // this.itemYtShow = this.formData.map((item, index) => index);
      // this.$nextTick(() => {
      //   this.formData.forEach((item, index) => {
      //     this.$refs.tree[index].setCheckedKeys([]);
      //     this.$refs.tree[index].setCheckedKeys(
      //       JSON.parse(item.EquipmentClassificationIds)
      //     );
      //   });
      //   console.log(this.$refs.tree);
      // });

      // setTimeout(() => {
      //   this.$nextTick(() => {
      //     this.formData = [JSON.parse(JSON.stringify(obj))];
      //     this.dialogVisible = true;
      //     this.itemYtShow = this.formData.map((item, index) => index)
      //     this.formData.forEach((item, index) => {
      //       console.log(item, index, '222222222222222222222')
      //       console.log(this.$refs['tree' + index], 'this.$refs.tree')
      //       // this.$refs.tree.setCheckedKeys([])
      //       // this.$refs.tree[0].setCheckedKeys(JSON.parse(item.EquipmentClassificationIds))
      //     })
      //   })
      // }, 200);
      // console.log(this.formData)
    },
    //追加
    BuildingAddition() {
      this.formData.push({})
      this.activeBuildingNames.push('楼栋' + `${this.formData.length - 1}`)
    },
    //移除
    BuildingRemoval(index) {
      this.formData.splice(index, 1)
      this.activeBuildingNames = this.activeBuildingNames.filter(
        (item) => item !== '楼栋' + index
      )
    },
    // 保存楼栋
    async louDonConfirm() {
      console.log('打印所有楼栋批量信息', this.formData)
      if (this.formData.length <= 0) {
        return this.$notify.error('请添加楼栋信息')
      }
      let codeFlag = this.formData.every(
        (item) =>
          item.BuildingCode && item.BuildingName && item.Construction_Area
      )
      if (!codeFlag)
        return this.$notify.error('请填写楼栋编号、楼栋名称、建筑面积')
      let resArr = []
      let errArr = []
      for (const item of this.formData) {
        let flag = await this.saveData({
          ...item,
          ProjectId: this.$route.query.id,
        })
        if (flag) {
          resArr.push(item.BuildingCode)
        } else {
          errArr.push(item.BuildingCode)
        }
      }
      if (resArr.length === this.formData.length) {
        this.$notify.success('保存成功')
      }
      if (errArr.length > 0) {
        this.$notify.error(
          resArr.join(',') + '保存成功，' + errArr.join(',') + '未能保存成功'
        )
      }
      setTimeout(() => {
        this.dialogVisible = false
        this.formData = []
        this.getDataList()
      }, 200)
      return
      this.formData.forEach((item) => {})
      let arr = []
      this.formData.length >= 1 &&
        this.formData.forEach(async (item, index) => {
          if (item.Formats) item.Formats = JSON.stringify(item.Formats)
          if (index !== 0) {
            for (const key in this.formData[0]) {
              if (
                (!item[key] && item[key] != 'BuildingCode') ||
                (key == 'Formats' && item[key] == '{}')
              )
                item[key] = this.formData[0][key]
            }
          }
          let flag = await this.saveData({
            ...item,
            ProjectId: this.$route.query.id,
          })
          if (flag) arr.push(index + 1)
        })
      let str = arr.join(',')
      if (arr.length > 0) this.$notify.error(str + '未能保存成功')
      else this.$notify.success('操作成功')

      this.dialogVisible = false
      console.log('打印结果旁边的this.formData', this.formData)
      setTimeout(() => {
        this.formData = []
        this.getDataList()
      }, 200)
    },
    getYeTaiList() {
      // this.$http
      //   .post(
      //     "/Base_ProjectManage/Project_DictionaryMain/GetTreeDataListByDicKey?DicKey=BuildingFormats"
      //   )
      //   .then((res) => {
      //     this.YetaiList = res.Data;
      //   });
      this.$http
        .post('/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey', {
          Condition: 'DicKey',
          Keyword: 'BuildingFormats',
        })
        .then((res) => {
          if (res.Success) this.YetaiList = res.Data.DictionaryDetailsList
        })
    },

    getDataList() {
      this.$http
        .post('/Base_ProjectManage/Project_Building/GetDataList', {
          Search: {
            Condition: 'ProjectId',
            Keyword: this.$route.query.id,
          },
        })
        .then((res) => {
          console.log(res)
          if (res.Success) {
            // if (res.Data) {
            //   res.Data.forEach((item) => {
            //     if (item.Formats) {
            //       item.Formats = JSON.parse(item.Formats);
            //       item.yetai = [];
            //       for (const key in item.Formats) {
            //         item.yetai.push(key);
            //       }
            //       item.yetaiShow = true;
            //     }
            //   });
            // }
            this.data = res.Data
          }
        })
    },
    async saveData(obj) {
      let flag = false
      await this.$http
        .post('/Base_ProjectManage/Project_Building/SaveData', obj)
        .then((res) => {
          console.log('获取saveData接口结果数据', res)
          if (res.Success) flag = true
          else flag = false
        })
      return flag
    },
  },
}
</script>

<style lang="scss" scoped>
/*覆盖element表格的表头字体样式*/

.list_column {
  text-align: right;
  margin-right: 20px;
}

::v-deep .el-drawer__header {
  font-size: 20px !important;
  /* 修改字体大小 */
  text-align: center !important;
  /* 修改文字居中对齐 */
  margin-bottom: 20px !important;
  /* 修改标题下外边距 */
}

::v-deep .el-drawer__body {
  margin: 0 10px 10px;
}

.louDon {
  display: flex;
  flex-wrap: wrap;

  .addLouDon {
    display: block;
    border: 2px dashed #ccc;
    text-align: center;
    line-height: 90px;
    font-size: 40px;
    color: #999;

    &:hover {
      border-color: #409eff;
      color: #409eff;
    }
  }
}

.form {
  padding: 0 30px 60px;
  background: #fff;
  position: relative;
  overflow-y: scroll;

  ::v-deep .el-collapse,
  .el-collapse-item__wrap {
    border: none !important;
  }

  ::v-deep .el-card__body:first-child {
    padding: 5px 20px !important;
  }

  // ::v-deep .el-collapse-item__header {
  //   border-bottom: none !important;
  // }

  ::v-deep .el-collapse-item__wrap {
    border-bottom: none !important;

    .el-collapse-item__content {
      padding-bottom: 10px;
    }
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e0e0e0;
  }

  &::-webkit-scrollbar-track {
    /* 滚动条里面轨道 */
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    background: transparent;
  }

  h4 {
    margin: 0;
    margin-bottom: 10px;
    padding-left: 5px;
  }

  .textAlignRight {
    text-align: left;
    line-height: 40px;
  }
}

.buttonGroup {
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  background: #fff;
  margin: 0;
  padding: 10px;
  border-top: 1px solid #ccc;
  width: 100%;
  z-index: 999;
}

// ::v-deep .el-tree-node__content .el-tree-node__children {
//   display: flex;
//   flex-wrap: wrap !important;
// }

::v-deep .el-tree-node__children .el-tree-node {
  float: left;
}
</style>
